import { render, staticRenderFns } from "./RgWarrantiesList.vue?vue&type=template&id=19d51046&scoped=true"
import script from "./RgWarrantiesList.vue?vue&type=script&lang=js"
export * from "./RgWarrantiesList.vue?vue&type=script&lang=js"
import style0 from "./RgWarrantiesList.vue?vue&type=style&index=0&id=19d51046&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d51046",
  null
  
)

export default component.exports